/**
 * IL y a 3 sections de filtres possibles : thematique || format || periode
 * si thematique-1 || thematique-2 && format-1 && periode-1 || periode-2
 * 
 * 1 - RÃ©cupÃ©rÃ©r le nom des filtres existants dans le jSON
 * 2 - Retourne un tableau avec les value des inputs cochÃ©s
 * 3 - Retourne un nouveau Json avec les Ã©lÃ©ments filtrÃ©s
 * 
 * - Fonction Si on coche "voir tout", on coche tous les filtres de la sÃ©ction
 * - Si un des Ã©lÃ©ments n'est pas cochÃ© "voir tout se dÃ©coche", Ã  l'inverse si tous les Ã©lÃ©ments sont cochÃ©s "voir tout" se coche
 * 
 */

// 1. Import the functions
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export const filter = {
	init() {
		// constructor
		this.form = document.querySelector('.filter');
		this.filters = this.form.querySelectorAll('.filter__item input');

		// GESTION DES CHECK POUR "VOIR TOUT"
		this.inputSeeAll();
		this.controller();
	},

	updateJson(json) {
		let newJson = [];
		this.getArrayfromFiltersChecked();
		
		// console.log (this.allFamilyFilter);
		// console.log ("----------");
		
		let thematique = this.allFamilyFilter[0]['thematique'];
		let type = this.allFamilyFilter[1]['type'];
		let periode = this.allFamilyFilter[2]['periode'];

		// console.log("ThÃ©matique", thematique);
		// console.log("Type", type);
		// console.log("PÃ©riode", periode);

		json.forEach((news) => {
			// console.log ("Check thematique ... " + news.filter_thematique);
			// console.log ("Check type ... " + news.filter_type);
			// console.log ("Check periode ... " + news.filter_periode);
			
			let themeFilter = news.filter_thematique.split(',');
			let typeFilter = news.filter_type.split(',');
			let periodeFilter = news.filter_periode.split(',');
			
			// console.log (thematique.some((filterName) => themeFilter.includes(filterName)));
			// console.log (type.some((filterName) => typeFilter.includes(filterName)));
			// console.log (periode.some((filterName) => periodeFilter.includes(filterName)));
			
			// SI THEMATIQUES && TYPES && PERIODE
			if (
				thematique.some((filterName) => themeFilter.includes(filterName)) &&
				type.some((filterName) => typeFilter.includes(filterName)) &&
				periode.some((filterName) => periodeFilter.includes(filterName))
			) {
				newJson.push(news);
			}
		});

		// console.log(newJson);
		return newJson;
	},

	getArrayfromFiltersChecked() {
		// RETOURNE UN TABLEAU DE TOUS LES FILTRES SELECTIONNÃ‰S. (THEMATIQUE, PERIODE, TYPE)
		this.thematiqueFilters = [];
		this.periodeFilters = [];
		this.typeFilters = [];
		this.allFamilyFilter = [];

		this.filters.forEach((element) => {
			if (element.checked) {
				if (element.parentNode.classList.contains('type')) {
					this.typeFilters.push(element.id);
				}
				if (element.parentNode.classList.contains('thematique')) {
					this.thematiqueFilters.push(element.id);
				}
				if (element.parentNode.classList.contains('periode')) {
					this.periodeFilters.push(element.id);
				}
			}
		});

		return (this.allFamilyFilter = [
			{ thematique: this.thematiqueFilters },
			{ type: this.typeFilters },
			{ periode: this.periodeFilters }
		]);
	},

	inputSeeAll() {
		let inputList = document.querySelectorAll('.filter__list');

		inputList.forEach((list) => {
			const seeAll = list.querySelector('.seeall input');
			const items = list.querySelectorAll('.filter__item:not(.seeall) input');
			let valOfInput = [];

			items.forEach((el, index) => {
				// AJOUTE DANS VALOFINPUT LES VALEURS DE TOUS LES CHECK
				valOfInput[index] = el.checked;
				el.onchange = function(e) {
					// CHANGE LA VALEUR AU ONCHANGE
					valOfInput[index] = e.target.checked;

					const CHECKED_INPUTS = []

					list.querySelectorAll('.filter__item:not(.seeall) input').forEach(el => el.checked && el.name ? CHECKED_INPUTS.push(el.dataset.slug) : null)
					let labels = '';
					if (CHECKED_INPUTS.length > 2) {
						labels = `${CHECKED_INPUTS[0]}, ${CHECKED_INPUTS[1]}, ...`;
					} else if (CHECKED_INPUTS.length === 2) {
						labels = `${CHECKED_INPUTS[0]}, ${CHECKED_INPUTS[1]}`;				
					} else if (CHECKED_INPUTS.length === 1) {
						labels = CHECKED_INPUTS[0];
					}  
					else if (CHECKED_INPUTS.length === 0 || items.length === CHECKED_INPUTS.length) {
						labels = el.parentNode.parentNode.parentNode.querySelector('button').dataset.title;
					}  
					el.parentNode.parentNode.parentNode.querySelector('button').innerHTML = labels;
				
					// SI TOUTES LES VALEURS SONT VRAIES
					if (valOfInput.every((val) => val === true)) {
						seeAll.checked = true;
					} else {
						seeAll.checked = false;
					}
				};
			});

			seeAll.onchange = (e) => {
				const CHECKED_INPUTS = []
				const $btn = seeAll.parentNode.parentNode.parentNode.querySelector('button');

				list.querySelectorAll('.filter__item:not(.seeall) input').forEach(el => el.checked && el.name ? CHECKED_INPUTS.push(el.dataset.slug) : null)

				if (CHECKED_INPUTS.length || items.length === CHECKED_INPUTS.length) {
					$btn.innerHTML = $btn.dataset.title;
				}
				// console.log("voir tout", e.target.checked);
				items.forEach((el, index) => {
					el.checked = e.target.checked;
					valOfInput[index] = e.target.checked;
				});
			};
		});
	},

	controller() {
		let toggleButton = document.querySelectorAll('.filter__title');

		// OUVERTURE DES FILTRES
		if (toggleButton) {
			toggleButton.forEach((button) => {
				button.addEventListener('click', () => {
					if (window.matchMedia('(min-width: 1024px)').matches) {
						// SI DESKTOP
						button.parentElement.classList.contains('opened')
							? filter.close(button.parentElement)
							: filter.open(button.parentElement);
					} else {
						// INVERSE POUR MOBILE
						!button.parentElement.classList.contains('opened')
							? filter.open(button.parentElement)
							: filter.close(button.parentElement);
					}
				});
			});
		}

		// FERME LES ONGLETS 2 + 3
		if (window.matchMedia('(max-width: 1024px)').matches) {
			document.querySelector('.filter__col:nth-child(n+3)').classList.add('opened')
			document.querySelector('.filter__col:nth-child(n+4)').classList.add('opened')

		}

		let toggleFilter = document.querySelector('.filter__toggle');

		if (window.matchMedia('(max-width: 1024px)').matches) {
			if (toggleFilter) {
				// AU CLIC SUR LE BOUTON FILTRER LES RÃ‰SULTATS
				toggleFilter.addEventListener('click', () => {
					let container = document.querySelector('.container ');
					container.classList.contains('filtersOpened')
						? filter.flapFilters(false)
						: filter.flapFilters(true);
				});

				// AU CLIC SUR LE VOILE FERMETURE FENÃŠTRE DE FILTRES
				document.querySelector('.voile').addEventListener('click', (e) => {
					filter.flapFilters(false);
				});
			}
		}
	},

	open(filterCol) {
		filterCol.classList.add('opened');
	},

	close(filterCol) {
		filterCol.classList.remove('opened');
	},

	flapFilters(toggle) {
		let container = document.querySelector('.container ');
		let filter = container.querySelector('.filter');

		if (toggle) {
			container.classList.add('filtersOpened');
			filter.style.height = window.innerHeight + 'px';
			filter.style.maxHeight = window.innerHeight + 'px';
			disableBodyScroll(document.querySelector('body'));
			disableBodyScroll(document.querySelector('.filter'));
			// container.sytle.height = "200px"
		} else {
			container.classList.remove('filtersOpened');
			enableBodyScroll(document.querySelector('.filter'));
			enableBodyScroll(document.querySelector('body'));
		}
	}
};
